var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 63.3333H46.6668V19.9999L67.9802 29.1333C68.5802 29.3905 69.0914 29.8182 69.4505 30.3634C69.8096 30.9085 70.0007 31.5471 70.0002 32.1999V63.3333H76.6668V69.9999H3.3335V63.3333H10.0002V18.8333C10.0001 18.1883 10.1871 17.5572 10.5385 17.0164C10.89 16.4757 11.3908 16.0485 11.9802 15.7866L37.6568 4.37328C37.9109 4.26043 38.1891 4.2129 38.4661 4.23502C38.7432 4.25715 39.0104 4.34822 39.2433 4.49995C39.4762 4.65168 39.6674 4.85925 39.7996 5.10377C39.9318 5.34829 40.0008 5.62199 40.0002 5.89995V63.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2Fill);
export default __webpack_public_path__ + "static/media/building-2-fill.2001838f9ac5a00d65bacff938ef78a4.svg";
export { ForwardRef as ReactComponent };